import React from 'react';
import { useContext } from 'react';
import { enrollmentContext } from '../../../../../../hoc/context/enrollment/enrollment-context';
import context from '../../../../../../hoc/context/product/context';
import { DefaultQuestion, DefaultQuestionProps } from '../default/default';

interface PerformerQuestionProps extends DefaultQuestionProps {}

export const PerformerQuestion = ({
	question,
	answer,
	answerQuestion,
}: PerformerQuestionProps) => {
	const ctxt = useContext(context);
	const enrollmentCtxt = useContext(enrollmentContext);
	const setPerformer = (inputAnswer: 'patient' | 'caregiver') => {
		//TODO: Temporary fix for Entresto
		enrollmentCtxt.resetInput();
		enrollmentCtxt.input.performer = inputAnswer;
		ctxt.changeLanguageVariant(inputAnswer);
	};
	return (
		<>
			<DefaultQuestion
				question={question}
				answer={answer}
				answerQuestion={(
					value: 'patient' | 'caregiver',
					emitEvent: boolean
				) => {
					setPerformer(value);
					answerQuestion(value, emitEvent);
				}}
			/>
		</>
	);
};
